/**
 * IndexedDB service for local project storage
 */

const DB_NAME = 'LoopAiAdStudioDB';
const PROJECT_STORE = 'projects';
const DB_VERSION = 2;

let dbPromise = null;

const openDB = () => {
    if (dbPromise) return dbPromise;

    dbPromise = new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = () => {
            console.error('IndexedDB error:', request.error);
            reject(request.error);
        };

        request.onsuccess = () => resolve(request.result);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(PROJECT_STORE)) {
                db.createObjectStore(PROJECT_STORE, { keyPath: 'id' });
            }
        };
    });
    return dbPromise;
};

export const saveProjectToIndexedDB = async (project) => {
    try {
        // Ensure project has an id (required for IndexedDB keyPath)
        if (!project || !project.id) {
            console.warn('⚠️ Cannot save project to IndexedDB: missing id', project);
            return;
        }
        
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(PROJECT_STORE, 'readwrite');
            const store = transaction.objectStore(PROJECT_STORE);
            const request = store.put(project);

            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    } catch (e) {
        console.error("Local save failed:", e);
        throw e;
    }
};

export const loadProjectFromIndexedDB = async (id) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(PROJECT_STORE, 'readonly');
            const store = transaction.objectStore(PROJECT_STORE);
            const request = store.get(id);

            request.onsuccess = () => resolve(request.result || null);
            request.onerror = () => reject(request.error);
        });
    } catch (e) {
        console.error("Failed to load from IndexedDB:", e);
        return null;
    }
};

export const deleteProjectFromIndexedDB = async (id) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(PROJECT_STORE, 'readwrite');
            const store = transaction.objectStore(PROJECT_STORE);
            const request = store.delete(id);

            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    } catch (e) {
        console.error("Failed to delete from IndexedDB:", e);
        throw e;
    }
};
